<template>
  <stripe-pricing-table :pricing-table-id="pricingTableId" :publishable-key="publishableKey">
  </stripe-pricing-table>
</template>
<script>
export default {
  computed: {
    pricingTableId() {
      return process.env.VUE_APP_STRIPE_PRICING_TABLE_ID;
    },
    publishableKey() {
      return process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
    },
  },
};
</script>
<style lang="css">
stripe-pricing-table iframe .PricingTable {
  background-color: none !important;
}
</style>
